import colors from '@/neural/colors/colors'
import grays from '@/neural/colors/grays'
import multi from '@/neural/colors/multi'

export default {
  ...colors,
  ...grays,
  ...multi
}
